const state = {
  content: '',
  color: '',
  timeout: -1
}

const mutations = {
  showMessage (state, payload) {
    state.content = payload.content
    state.color = payload.color
    state.timeout = payload.timeout
  }
}

export default {
  namespaced: true,
  state,
  mutations,
}